// TODO: Remove use of filteredByPositiveAdjudicationCharges when ready.
import { SearchRecord } from 'types/record';
import { Search } from 'types/search';
import { CandidateStoryRequestItem } from 'types/candidateStories';

/**
 * Build a set of requested item IDs from candidate story report items.
 *
 * @param reportItems Items from the candidate story request
 * @returns Set of requested `source_id` values
 */
export const getRequestedItemIds = (
  reportItems: CandidateStoryRequestItem[] = [],
): Set<string> => {
  return new Set(reportItems.map(item => item.source_id));
};

/**
 * Gather all charges associated with a record, including filtered/hidden ones.
 *
 * @param record Search record
 * @returns Flattened array of charges for the record
 */
export const getChargesForRecord = (record: SearchRecord) => {
  return [
    ...record.charges,
    ...record.filteredByPositiveAdjudicationCharges,
    ...record.chargesHiddenByAssess,
  ];
};

/**
 * Determine whether a record includes any requested charge.
 *
 * @param record Search record to evaluate
 * @param chargeIds Set of requested charge IDs
 * @returns True if any charge on the record matches a requested ID
 */
export const hasCharges = (record: SearchRecord, chargeIds: Set<string>) => {
  const charges = getChargesForRecord(record);
  return charges.some(c => c && chargeIds.has(c.id));
};

/**
 * Return records across all searches whose charges are present in report items.
 *
 * @param searches Search or array of searches containing records
 * @param reportItems Candidate story request items
 * @returns Records that have at least one requested charge
 */
export const getRequestedRecords = (
  searches: Search | Search[],
  reportItems: CandidateStoryRequestItem[] = [],
): SearchRecord[] => {
  const searchesList = Array.isArray(searches) ? searches : [searches];
  const chargeIds = getRequestedItemIds(reportItems);
  return searchesList
    .flatMap(s => [...s.records, ...s.filteredByPositiveAdjudicationRecords])
    .filter(r => hasCharges(r as SearchRecord, chargeIds)) as SearchRecord[];
};
